var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { update } from "./services";
import EditSecretsForm from "@/components/ConfigTemplates/EditSecretsForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditSecrets',
    props: {
        objectStore: null,
        template: null
    },
    setup(__props) {
        const props = __props;
        const title = computed(() => { var _a; return `Update Storage Location ${(_a = props.objectStore) === null || _a === void 0 ? void 0 : _a.name} Secrets`; });
        function onUpdate(secretName, secretValue) {
            return __awaiter(this, void 0, void 0, function* () {
                const payload = {
                    secret_name: secretName,
                    secret_value: secretValue,
                };
                const args = { user_object_store_id: String(props.objectStore.uuid) };
                yield update(Object.assign(Object.assign({}, args), payload));
            });
        }
        return { __sfc: true, props, title, onUpdate, EditSecretsForm };
    }
});
